module.exports = __webpack_public_path__ + "static/media/temperature-hot.f2fe1555.svg";